<template>
  <div>
    <v-layout column>
      <p class="text-xs-center">
        Upload a JPEG, PNG or PDF less than 5mb in size.
      </p>
      <p class="text-xs-center">
        <i>We recommend using the FREE GeniusScan app to easily scan and convert documents to PDF format.</i>
      </p>

      <v-layout :column="$vuetify.breakpoint.xsOnly" align-center class="text-xs-center">
        <v-flex grow order-xs2 order-sm1 class="text-sm-right">
          <a href="https://apps.apple.com/us/app/genius-scan-pdf-scanner/id377672876">
            <img src="/img/app_store.svg" alt="Download on the App Store" height="50">
          </a>
        </v-flex>
        <v-flex shrink order-xs1 order-sm2>
          <img src="/img/genius_scan.png" alt="GeniusScan" width="50" height="50" style="border-radius: 4px; margin: 10px">
        </v-flex>
        <v-flex grow order-xs3 order-sm3 class="text-sm-left">
          <a href="https://play.google.com/store/apps/details?id=com.thegrizzlylabs.geniusscan.free">
            <img src="/img/google_play.svg" alt="Get it on Google Play" height="50">
          </a>
        </v-flex>
      </v-layout>
    </v-layout>

    <Documents :profile="profile" />
  </div>
</template>

<script>
// Components
import Documents from '@/components/candidate/profile/edit/Documents'

export default {
  components: { Documents },

  props: { profile: { type: Object, required: true } },
}
</script>
